if (!customElements.get('rebuy-featured')) {
  class RebuyFeatured extends HTMLElement {
    constructor() {
      super();
      this.rebuyApiKey = this.dataset.rebuyApiKey;
      this.rebuySource = this.dataset.rebuySource;
      this.rebuyApiContainer = this.querySelector('#rebuy-api-container');
      this.swiper = null;
      this.leftArrow = this.querySelector('.custom__arrow-left-feat-prods');
      this.rightArrow = this.querySelector('.custom__arrow-right-feat-prods');
      this.sectionId = this.dataset.sectionId;
      this.cardDataCache = new Map();
    }

    connectedCallback() {
      this.initRebuyFeatured();
    }

    initRebuyFeatured() {
      if (this.rebuyApiContainer) {
        const rebuyTestSlider = this.rebuyApiContainer.querySelector('.custom__featured-slider');
        rebuyTestSlider.innerHTML = '';

        const requestParameters = new URLSearchParams({
          key: this.rebuyApiKey,
          source: this.rebuySource,
          format: "pretty",
          limit: 12
        });

        let fetchURL = ''

        if (this.rebuySource == '') {
          fetchURL = `https://rebuyengine.com/api/v1/products/recommended?${requestParameters}&limit=8`
        } else {
          fetchURL = 'https://rebuyengine.com/api/v1/custom/id/' + this.rebuySource + `?${requestParameters}&limit=8`
        }

        fetch(fetchURL)
          .then(response => {
            if (!response.ok) {
              throw new Error(`HTTP error! status: ${response.status}`);
            }
            return response.json();
          })
          .then(data => {
            const products = data.data;
            // Display the results using the same structure as card-product-rebuy
            if (products && products.length > 0) {
              // Add swiper class and create wrapper structure
              rebuyTestSlider.classList.add('swiper');
              let html = '<div class="swiper-wrapper">';

              products.forEach(product => {
                const productHandle = this.getProductHandle(product);
                const imageUrl = product.image ? product.image.src || '' : '';
                const imageAlt = product.image ? product.image.alt || product.title || 'Product image' : '';
                const productLink = product.link || '#';

                const variants = product.variants || [];
                const isSingleVariant = variants.length === 1;
                const firstVariantId = isSingleVariant ? variants[0].id : null;

                const toDollars = (val) => { const n = typeof val === 'number' ? val : parseFloat(val); return isNaN(n) ? 0 : n; };
                // Rebuy variant prices are already in dollars; product.price is in cents when numeric
                const variantPrices = variants.map(v => toDollars(v.price)).filter(p => p > 0);
                const fallbackPrice = product.price
                  ? (typeof product.price === 'number' ? product.price / 100 : toDollars(product.price))
                  : 0;
                const minPrice = variantPrices.length > 0 ? Math.min(...variantPrices) : fallbackPrice;
                const maxPrice = variantPrices.length > 0 ? Math.max(...variantPrices) : fallbackPrice;
                const priceVaries = minPrice > 0 && maxPrice > 0 && minPrice !== maxPrice;
                const priceDisplay = (priceVaries ? 'From ' : '') + '$' + minPrice.toFixed(2);

                const buttonHtml = isSingleVariant && firstVariantId
                  ? `<button class="quick__shop-btn quick__shop-btn--atc" data-quick-add-variant="${firstVariantId}">Add to Cart</button>`
                  : `<button class="quick__shop-btn quick__shop-btn--choose" data-id="${this.sectionId}-${product.id}"${productHandle ? ` data-product-handle="${productHandle}"` : ''}>Choose Size</button>`;

                html += `
                  <div class="swiper-slide">
                    <div class="knesko-card-wrapper underline-links-hover"${productHandle ? ` data-product-handle="${productHandle}"` : ''}>
                      <div class="knesko-card knesko-card--standard knesko-card--media">
                        <div class="knesko-card__inner color-background-2 ratio" style="--ratio-percent: 133.33%;">
                          ${imageUrl ? `
                            <div class="knesko-card__media">
                              <div class="media media--transparent media--hover-effect">
                                <a href="${productLink}" class="whole-card-link full-unstyled-link"><span class="visually-hidden">${product.title || ''}</span></a>
                                <img src="${imageUrl}" alt="${imageAlt}" width="533" loading="lazy" class="motion-reduce">
                              </div>
                            </div>
                            <div class="hover-media">
                              <div class="media media--transparent media--hover-effect" data-target="card-hover"></div>
                            </div>
                          ` : ''}
                          <div class="knesko-card__content">
                            <div class="knesko-card__information">
                              <div class="knesko-card__heading">
                                <a href="${productLink}" class="full-unstyled-link">${product.title || ''}</a>
                              </div>
                            </div>
                            ${buttonHtml}
                            <div class="knesko-card__badge top left" data-target="card-badge"></div>
                          </div>
                        </div>
                        <div class="knesko-card__content">
                          <div class="knesko-card__information">
                            <div class="knesko-card__vendor"><div class="uppercase">${product.product_type || ''}</div></div>
                            <div class="knesko-card__heading">
                              <a href="${productLink}">${product.title || ''}</a>
                            </div>
                            <div class="knesko-card-information">
                              <div data-target="card-reviews"></div>
                              <div class="price card-price" data-target="card-price">
                                <div class="price__container">
                                  <span class="price-item price-item--regular">${priceDisplay}</span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                `;
              });

              html += '</div><div class="swiper-pagination"></div>';
              rebuyTestSlider.innerHTML = html;

              // Initialize Swiper slider
              const paginationEl = rebuyTestSlider.querySelector('.swiper-pagination');

              // Check if Swiper is already initialized
              if (!rebuyTestSlider.swiper) {
                this.swiper = new Swiper(rebuyTestSlider, {
                  slidesPerView: 'auto',
                  spaceBetween: 0,
                  loop: false,
                  speed: 500,
                  centerInsufficientSlides: true,
                  centeredSlides: true,
                  grabCursor: true,
                  navigation: {
                    nextEl: this.rightArrow,
                    prevEl: this.leftArrow,
                  },
                  pagination: {
                    el: paginationEl,
                    clickable: true,
                    renderBullet: function (index, className) {
                      return '<div class="' + className + ' recommendations-slide-dot">&nbsp;</div>';
                    },
                  },
                  breakpoints: {
                    1000: {
                      slidesPerView: 4,
                      centeredSlides: false,
                    }
                  },
                  on: {
                    init: () => {
                      this.handleArrowVisibility();
                    },
                    slideChange: () => {
                      this.handleArrowVisibility();
                    },
                    resize: () => {
                      this.handleArrowVisibility();
                    }
                  }
                });
              }

              // Update card data-targets with server-rendered quickshop fragments
              this.updateCardTargets();

            } else {
              rebuyTestSlider.innerHTML = '<p>No products found in Rebuy API response</p>';
            }
          })
          .catch(error => {
            console.error('Rebuy API error:', error);
            rebuyTestSlider.innerHTML = `<p style="color: red;">Error loading Rebuy data: ${error.message}</p>`;
          });
      }
    }

    getProductHandle(product) {
      if (product && typeof product.handle === 'string' && product.handle) {
        return product.handle;
      }

      const link = product && typeof product.link === 'string' ? product.link : '';
      const match = link.match(/\/products\/([^/?#]+)/i);

      return match ? decodeURIComponent(match[1]) : '';
    }

    async fetchCardData(handle) {
      if (!handle) return null;
      if (this.cardDataCache.has(handle)) return this.cardDataCache.get(handle);

      const params = new URLSearchParams({
        section_id: 'quick-shop-modal-render'
      });

      const response = await fetch(`/products/${handle}?${params.toString()}`);
      if (!response.ok) return null;

      const html = await response.text();
      const parsed = new DOMParser().parseFromString(html, 'text/html');
      const modal = parsed.querySelector('.modal.quickshop');
      if (!modal) return null;

      const data = {
        hover: modal.querySelector('[data-card-hover]')?.innerHTML || '',
        badge: modal.querySelector('[data-card-badge]')?.innerHTML || '',
        reviews: modal.querySelector('[data-card-reviews]')?.innerHTML || '',
        price: modal.querySelector('[data-card-price]')?.innerHTML || ''
      };

      this.cardDataCache.set(handle, data);
      return data;
    }

    /**
     * For each card-wrapper, find the corresponding quickshop modal by product id,
     * and replace the content of data-target elements (card-hover, card-badge, card-price)
     * with the content from the modal's data-card-* elements.
     */
    async updateCardTargets() {
      const cardWrappers = this.querySelectorAll('.knesko-card-wrapper.underline-links-hover');
      cardWrappers.forEach(async (card) => {
        const productHandle = card.getAttribute('data-product-handle') ||
          card.querySelector('.quick__shop-btn[data-product-handle]')?.getAttribute('data-product-handle');
        if (!productHandle) return;
        const data = await this.fetchCardData(productHandle);
        if (!data) return;

        const targets = [
          { el: card.querySelector('[data-target="card-hover"]'), html: data.hover },
          { el: card.querySelector('[data-target="card-badge"]'), html: data.badge },
          { el: card.querySelector('[data-target="card-reviews"]'), html: data.reviews },
        ];

        targets.forEach(({ el, html }) => {
          if (el && html) el.innerHTML = html;
        });
      });
    }

    handleArrowVisibility() {
      if (!this.swiper || !this.leftArrow || !this.rightArrow) return;

      const totalSlides = this.swiper.slides.length;
      const slidesPerView = typeof this.swiper.params.slidesPerView === 'number'
        ? this.swiper.params.slidesPerView
        : this.swiper.slides.length;
      const isLoop = this.swiper.params.loop;

      // Show/hide arrows based on number of slides
      if (totalSlides <= slidesPerView && !isLoop) {
        this.leftArrow.classList.add('custom__arrow--hidden');
        this.rightArrow.classList.add('custom__arrow--hidden');
      } else {
        this.leftArrow.classList.remove('custom__arrow--hidden');
        this.rightArrow.classList.remove('custom__arrow--hidden');
      }
    }

    disconnectedCallback() {
      if (this.swiper) {
        this.swiper.destroy(true, true);
        this.swiper = null;
      }
    }
  }

  customElements.define('rebuy-featured', RebuyFeatured);
}
